/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateTermDto } from '../../models/update-term-dto';

export interface InfoControllerUpdateTermV1$Params {
  key: string;
      body: UpdateTermDto
}

export function infoControllerUpdateTermV1(http: HttpClient, rootUrl: string, params: InfoControllerUpdateTermV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, infoControllerUpdateTermV1.PATH, 'post');
  if (params) {
    rb.query('key', params.key, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

infoControllerUpdateTermV1.PATH = '/api/v1/info/term';
